import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Combobox } from "@/components/ui/combobox";
import { Zap, Search, Compass, ArrowRight } from "lucide-react";
import { AiAsk } from "@/components/AiAsk";

export default function Onboarding() {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [vehicleId, setVehicleId] = useState("");

  useEffect(() => {
    Promise.all([
      api.get("/vehicles", { params: { category: "motor_listrik" } }),
      api.get("/vehicles", { params: { category: "sepeda_listrik" } }),
    ]).then(([m, b]) => setVehicles([...m.data.items, ...b.data.items])).catch(() => {});
  }, []);

  const proceed = async (to) => {
    api.post("/profile", {}).catch(() => {});
    navigate(to);
  };

  return (
    <div className="min-h-screen bg-navy dot-grid flex items-center justify-center p-6">
      <div className="w-full max-w-lg bg-white rounded-3xl p-8 shadow-2xl">
        <div className="flex items-center gap-2 font-heading font-extrabold text-navy mb-2">
          <span className="w-8 h-8 rounded-lg bg-teal flex items-center justify-center text-white"><Zap className="w-4 h-4" /></span>
          Selamat datang!
        </div>
        <h1 className="font-heading font-extrabold text-2xl text-navy mb-1" data-testid="onboarding-question">Motor apa yang sedang Anda pertimbangkan?</h1>
        <p className="text-sm text-muted-foreground mb-5">Cari dari database kami, lalu langsung cek kecocokannya — analisis pertama Anda gratis.</p>

        <div className="mb-4">
          <Combobox
            testId="onboarding-vehicle-select"
            options={vehicles.map((v) => ({ value: v.vehicle_id, label: `${v.brand} ${v.model}${v.variant ? ` ${v.variant}` : ""}` }))}
            value={vehicleId}
            onChange={setVehicleId}
            placeholder="Cari motor atau sepeda listrik…"
            searchPlaceholder="Ketik merek atau model…"
            emptyText="Model tidak ditemukan di database kami."
          />
        </div>
        <div className="flex flex-col gap-2">
          <Button data-testid="onboarding-check-vehicle" disabled={!vehicleId} onClick={() => proceed(`/tanjakan?vehicle=${vehicleId}`)} className="rounded-full bg-teal hover:bg-teal-hover h-12">
            <Search className="w-4 h-4 mr-2" />Cek Motor Ini
          </Button>
          <Button data-testid="onboarding-unsure" variant="outline" onClick={() => proceed("/bantu-memilih")} className="rounded-full h-12">
            <Compass className="w-4 h-4 mr-2" />Saya belum tahu — bantu saya memilih
          </Button>
        </div>

        <div className="mt-8 pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground mb-3">Punya pertanyaan lain? Tanyakan ke AI kami soal harga, spesifikasi, dan penghematan.</p>
          <AiAsk />
        </div>
        <div className="flex items-center justify-end mt-6">
          <button data-testid="onboarding-skip" onClick={() => proceed("/dashboard")} className="text-sm text-muted-foreground hover:text-navy inline-flex items-center gap-1">Lewati ke Dashboard<ArrowRight className="w-3.5 h-3.5" /></button>
        </div>
      </div>
    </div>
  );
}
